<template>
  <v-container fluid class="px-0 px-md-1">
     <div class="tables-basic mt-3">
        <Sidebar />
        <Tablero v-if="nuevaPeticion" :key="key.tablero" :busqueda="busquedaTablero" />
    </div>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import Sidebar from '@/components/pages/operacion/tablero/Sidebar.vue';
import Tablero from '@/components/pages/operacion/tablero/Tablero.vue';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    export default {
        title() {
            return this.$route.meta.title
        },
  components: {
    Sidebar,
    Tablero
  },
  data: () => ({
    nuevaPeticion: false
  }),
  watch: {
      'key.tablero': function(newVal, oldVal) { 
        this.verificandoBusqueda(true);
        this.nuevaPeticion = this.verificarBusqueda;
      }
  },
  computed: {
    ...mapState('Operacion', ['busquedaTablero', 'key', 'verificarBusqueda']),
  },
  methods: {
    ...mapMutations('Operacion', ['verificandoBusqueda']),
        },
};
</script>

